module.exports = __webpack_public_path__ + "img/base_datos_cliente.a3f0caff.gif";